import React from 'react';
import DropdownItemsFindHorse from './DropdownItemsFindHorse';
import DropdownItemsFindSupport from './DropdownItemsFindSupport';
import DropdownItemsAboutUs from './DropdownItemsAboutUs';
import DropdownItemsResources from './DropdownItemsResources';
import routeConfiguration from '../../../../routeConfiguration';
import { matchPathname } from '../../../../util/routes';
import { parse } from '../../../../util/urlHelpers';
import config from '../../../../config';

const { userTypeHorseowner, userTypeRider } = config;

export const FIND_HORSE = 'find-horse';
export const FIND_SUPPORT = 'find-support';
export const RESOURCES = 'resources';
export const ABOUT_US = 'about-us';

const parseCurrentPageUri = history => {
    const { role } = parse(history.location.search);
    const routes = matchPathname(history.location.pathname, routeConfiguration());
    const {
        route: { name },
    } = routes[0] || { route: { name: '' } };

    return { name, role };
};

export const dropdownsConfig = {
    [FIND_HORSE]: {
        label: 'Pferd finden',
        id: FIND_HORSE,
        items: <DropdownItemsFindHorse />,
        isSelected: history => {
            const { name, role } = parseCurrentPageUri(history);
            const isHorseFindPage = name === 'FindHorsePage';
            const isMatchingPage = name === 'MatchingPage';
            const isPricingPage = name === 'PricingPage';
            const isRiderRole = role === userTypeRider;
            return Boolean(isHorseFindPage || (isRiderRole && (isMatchingPage || isPricingPage)));
        },
    },
    [FIND_SUPPORT]: {
        label: 'Unterstützung finden',
        id: FIND_SUPPORT,
        items: <DropdownItemsFindSupport />,
        isSelected: history => {
            const { name, role } = parseCurrentPageUri(history);
            const isFindRiderPage = name === 'FindRiderPage';
            const isMatchingPage = name === 'MatchingPage';
            const isPricingPage = name === 'PricingPage';
            const isHorseownerRole = role === userTypeHorseowner;
            return Boolean(
                isFindRiderPage || (isHorseownerRole && (isMatchingPage || isPricingPage))
            );
        },
    },
    [RESOURCES]: {
        label: 'Ressourcen',
        id: RESOURCES,
        items: <DropdownItemsResources />,
        isSelected: history => {
            const { name } = parseCurrentPageUri(history);
            const isFlipAndWinPage = name === 'FlipAndWin';
            const isBlogPage = name === 'BlogPage';
            const isCommunityPage = name === 'CommunityPage';
            const isSupportPage = name === 'SupportPage';
            return Boolean(isFlipAndWinPage || isBlogPage || isCommunityPage || isSupportPage);
        },
    },
    [ABOUT_US]: {
        label: 'Über uns',
        id: ABOUT_US,
        items: <DropdownItemsAboutUs />,
        isSelected: history => {
            const { name } = parseCurrentPageUri(history);
            const isAboutUs = name === 'AboutUs';
            const isCareerPage = name === 'CareerPage';
            const isKodexPage = name === 'KodexPage';
            const isForClubs = name === 'ForClubs';
            const isBecomePartnerPage = name === 'BecomePartnerPage';
            const isForCompaniesPage = name === 'ForCompaniesPage';

            return Boolean(
                isAboutUs ||
                    isCareerPage ||
                    isKodexPage ||
                    isForClubs ||
                    isBecomePartnerPage ||
                    isForCompaniesPage
            );
        },
    },
};
